<template>
    <div>
        <router-view></router-view>
        <!-- Aviso de cookies: global, para que también salga en registro y login -->
        <CookieConsent />
    </div>
</template>

<script>
import CookieConsent from '@/components/Common/CookieConsent.vue';

export default {
    components: { CookieConsent },
};
</script>
